import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { QRCodeCanvas } from "qrcode.react";
import { readFaceContent, readShowPopup, readSignUrl, removeLoginPopup } from "../../../../../utils/storage";

const LoginPopup = () => {
  const [visible, setVisible] = useState(false);
  const [faceContent, setFaceContent] = useState('');
  const [signUrl, setSignUrl] = useState('');

  useEffect(() => {
    const showPopupVal = readShowPopup();
    if (showPopupVal === '1' || showPopupVal === 1) {
      setFaceContent(readFaceContent() || '');
      setSignUrl(readSignUrl() || '');
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
    removeLoginPopup();
  };

  if (!visible) {
    return null;
  }

  return (
    <Modal
      title="签约提示"
      open={visible}
      cancelText="关闭"
      okText="确定"
      maskClosable={false}
      onCancel={handleClose}
      onOk={handleClose}
    >
      <div style={{ textAlign: 'center', padding: '10px 0' }}>
        {faceContent && (
          <div
            style={{ marginBottom: '20px', fontSize: '14px', lineHeight: '24px', textAlign: 'left' }}
            dangerouslySetInnerHTML={{ __html: faceContent }}
          />
        )}
        {signUrl && (
          <div style={{ marginBottom: '10px' }}>
            <QRCodeCanvas value={signUrl} size={200} />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default LoginPopup;
